import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'involvements';

export function useGetAllInvolvements(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetInvolvement(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateInvolvement() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateInvolvement({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteInvolvement({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
